import React from 'react'
import { Images } from "../theme"
import { Link } from "gatsby"

const PDFBtns = () => {
    return (
        <div className="pdfbtns">
            <div className="fx fxdc">
                <div className="pd25">
                <h1>Natural Silver Research Papers</h1>
                    <div className="pdfsdv fxdc fxjcsb"> 
     
                    <div>
                        <span className="mobtn">
                            <a href={Images.breastCancer} target="_blank" rel="noopener noreferrer">breast_cancer</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.dosageSafetyChart} target="_blank" rel="noopener noreferrer">dosage_safety_chart</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.iso_ts_20660_2019_en} target="_blank" rel="noopener noreferrer">iso_ts_20660_2019_en</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.years120} target="_blank" rel="noopener noreferrer">120_years_of_nanosilver_history</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.silverSolMalaria} target="_blank" rel="noopener noreferrer">silver_sol_malaria_the_indian_practitioner</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.antifungalEffect} target="_blank" rel="noopener noreferrer">antifungal_effect_of_silver_nanoparticles_on_dermatophytes</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.appendix1} target="_blank" rel="noopener noreferrer">appendix_1_silver_the_science_behind_the_scene_method_of_action</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.colloidalSilver} target="_blank" rel="noopener noreferrer">colloidal_silver-a_novel_treatment_for_staphylococcus_aureus_biofilms</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.antifungalActivity} target="_blank" rel="noopener noreferrer">antifungal-activity-and-mode-of-action-of-silver-nano-particles-on-candida-albicans</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.dermalIrritation} target="_blank" rel="noopener noreferrer">dermal-irritation-and-corrosion-and-skin-sensitization-evaluation-of-silver-nanoparticles</a>
                        </span>
                    </div>

                    <div>
                        <span className="mobtn">
                            <a href={Images.defenseThreatReductionAgency} target="_blank" rel="noopener noreferrer">defense-threat-reduction-agency-silver-nanoparticles-neutralize-hemorrhagic-fever-viruses</a>
                        </span>
                    </div>

                    </div>
                </div>
            </div>
          </div>
    )
}

export default PDFBtns
